<template>
	<div class="search-widget">
		<v-search :show-tabs="showTabs" brand-theme="light" :brand-slug="brand_slug" :active-tab="activeTab" :hide-tabs="hideTabs" :date-start="dateStart" :date-end="dateEnd" :button-text="buttonText"></v-search>
	</div>
</template>
<script>
	// v-search is a custom element
	// the js needed is in index.html
	// isCustomElement is set in vue.config.js

	export default {
		name: 'SearchWidget',
		components: {},
		props: {
			brand_slug: String,
			activeTab: String,
      showTabs: String,
      hideTabs: String,
      dateStart: String,
      dateEnd: String,
      buttonText: String,
		},
		data() {
			return {};
		},
		computed: {},
		mounted() {},
		updated() {},
	};
</script>

<style scoped lang="scss">
	.search-widget {
		position: relative;
		// max-width: 1260px;
		margin: 0 auto;
    z-index: 9999;

		@media screen and (max-width: 1260px) {
			padding: 0 1rem;
		}

		@media screen and (max-width: 768px) {
			padding: 0rem 0rem 0 0rem;
		}
	}
</style>
